import { EuiPanel,EuiFlexGroup,EuiFlexItem,EuiFieldNumber, EuiSpacer, EuiButtonIcon } from '@elastic/eui';
import moment from 'moment';
import React, { useEffect, useMemo, useState, useRef } from 'react';
import { GridResultsScreen } from '../Grid/GridResultsScreen';
import { Action } from '../../../../components/Menus/interface';
import { Menu } from '../../../../components/Menus';
import {SelectorPeriodosContainer as SelectorPeriodos} from '../../../../components/Selectores/Periodos/container';
import { SelectorEjercicioContainer as SelectorEjercicio} from '../../../../components/Selectores/Ejercicio/container';

interface Props {
  data: any;
  onFilter(año:number, periodo:number): void;
}

export const PeriodosLogScreen = (props: Props) => {
  const _año = parseInt(moment().format('M')) === 1 ? parseInt(moment().format('Y'))-1 : parseInt(moment().format('Y'));
  
  const ref:any = useRef();

  let { data, onFilter } = props;

  let [año, setAño] = useState<number>(_año);
  let [periodo, setPeriodo] = useState<any>(-1);
  let [selected, setSelected] = useState<any>(undefined);

  useEffect(()=>{
    onRefresh()}
  ,[])

  const onChangeAño = (e:any) => {
    setAño(parseInt(e.target.value))
  }

  const onChangePeriodo = (value:any) => {
    setPeriodo(value)
  }

  const onRefresh = () =>{
    onFilter(año,(periodo == -1 ? undefined : periodo))
  }

  const onSelected = (selection: any) => {
    setSelected(selection[0])
  }
  
  const onExport = () =>{
    ref.current && ref.current.onExport();
  }

  const Actions: Action[] = useMemo(()=> [
    {handle:onExport,text:"Exportar",size:"s", isDisabled:false}
  ],[selected])


  const getForm = useMemo(() => {
    return (
        <EuiFlexGroup>
          <EuiFlexItem grow={false}> 
            <SelectorEjercicio value={año} onChange={(e:any) => setAño(e)} permitirNuevo={true} />
          </EuiFlexItem> 
          <EuiFlexItem> 
            <SelectorPeriodos fullWidth valueOfSelected={periodo} onChange={(value: any) => onChangePeriodo(value)} addTodos={true} /*getText isInvalid={isInvalidPeriodo}*/ />
          </EuiFlexItem>
          <EuiFlexItem grow={false} style={{justifyContent:'center'}}> 
            <EuiButtonIcon display="fill" iconType="refresh" aria-label="Recargar" onClick={()=> onRefresh()}/>
          </EuiFlexItem>
          <EuiFlexItem>
            <Menu actions={Actions}/>
          </EuiFlexItem>
        </EuiFlexGroup>
    );
  },[año,periodo,onChangeAño,onChangePeriodo])

  const getView = useMemo(() => {
    return (
      <>
         <GridResultsScreen
          data={data}
          onSelected={onSelected}
          selector={false}
          menu={false}
          ref={ref}
        />
        </>
    )
  },[data, onSelected])

  return (
        <>
          {getForm}
          <EuiSpacer size="m"/>
          {getView}
        </>
  );
};

export default PeriodosLogScreen;
